import moment from "moment-timezone";
import {
  ElementViewForClipboardProps,
  ElementViewProps,
} from "../AtomicElementView";
import styles from "./DateContent.module.scss";
import getClasses from "utils/getClasses";

function parseRawData(data) {
  if (!data) {
    return "";
  }

  if (/^\d\d\d\d-\d\d-\d\d$/.test(data)) {
    return data;
  }

  const parsed = moment(data).format("YYYY-MM-DD");
  if (parsed !== "Invalid date") {
    return parsed;
  }

  return "";
}

export function DateContentForClipboard({
  data: rawData,
}: ElementViewForClipboardProps<DateElement>) {
  const data = parseRawData(rawData);

  return <div>Date: {data || "No Date Selected"}</div>;
}

export default function DateContent({
  data: rawData,
  element,
  onChange,
  isLocked,
  isPrintMode,
  disabled,
  showAsMissing,
}: ElementViewProps<DateElement>) {
  const data = parseRawData(rawData);

  if (isPrintMode || isLocked) {
    return (
      <div>
        <div>
          <span className={styles.answerAsTextLabel}>Date: </span>
          <span className={styles.answerAsText}>
            {data || "No Date Selected"}
          </span>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className={styles.answerWrapper}>
        <label htmlFor={element.id}>Date:</label>
        <input
          id={element.id}
          type="date"
          className={getClasses(
            styles.answer,
            showAsMissing && !data && styles.missing,
          )}
          value={data}
          onChange={(event) => onChange(event.target.value)}
          disabled={disabled || isLocked}
        />
      </div>
    </div>
  );
}
